// extracted by mini-css-extract-plugin
export var productImage = "_ov-1";
export var viewLink = "_ov-2";
export var wishlistItem = "_ov-0";